import { render } from "./food.vue?vue&type=template&id=24ba926a&scoped=true"
import script from "./food.vue?vue&type=script&lang=js"
export * from "./food.vue?vue&type=script&lang=js"

import "./food.vue?vue&type=style&index=0&id=24ba926a&lang=less&scoped=true"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ba926a"]])

export default __exports__